// extracted by mini-css-extract-plugin
export default {"botones":"Capsules_botones__izi7f"};